export default __webpack_public_path__ + "static/media/HG_0109.9d9ce669.jpg";